import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';

import { Regions } from '@/constants';
import { PostgrestEndpoints } from '@/requests';
import { Region } from '@/types';

import { postgrestApi } from '../postgrest-api';
import { APP_SETTINGS_SLICE_KEY } from './app-settings.constants';

export const REGION_KEY = 'userRegion';

type AppSettingsState = {
  region: Region;
  theme?: 'light';
};

const initialState: AppSettingsState = {
  region: (localStorage.getItem(REGION_KEY) || Regions.CAN) as Region,
  theme: 'light',
};

export const updateRegion = createAsyncThunk(
  `${APP_SETTINGS_SLICE_KEY}/updateRegion`,
  async (payload: { region: Region }) => {
    localStorage.setItem(REGION_KEY, payload.region);
    return payload;
  },
);

const extraReducers = (builder: ActionReducerMapBuilder<AppSettingsState>) => {
  builder.addCase(updateRegion.fulfilled, (state, { payload }) => {
    state.region = payload.region;
  });
};

export const appSettingsSlice = createSlice({
  name: APP_SETTINGS_SLICE_KEY,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
  initialState,
  extraReducers,
});

export const appSettingsApi = postgrestApi.injectEndpoints({
  endpoints: builder => ({
    fetchUserIpRegion: builder.query<Region, void>({
      query: () => ({
        url: PostgrestEndpoints.REQUEST_REGION,
      }),
      transformResponse: ({ country }: { country: string }) => {
        switch (country) {
          case 'US':
            return Regions.USA;
          case 'CA':
            return Regions.CAN;
          case 'GB':
            return Regions.GBR;
          default:
            return Regions.CAN;
        }
      },
    }),
    fetchMarketingSignupPromptInfo: builder.query<{ delayMs: number }, void>({
      query: () => ({
        url: PostgrestEndpoints.GET_POC_VALUE,
        params: {
          key: 'marketing_modal',
        },
      }),
    }),
  }),
});

export const {
  useFetchUserIpRegionQuery,
  useFetchMarketingSignupPromptInfoQuery,
} = appSettingsApi;

export const appSettingsActions = appSettingsSlice.actions;
export const { reducer: appSettingsReducer } = appSettingsSlice;
